module.exports = __webpack_public_path__ + "media/components/country-flag/static/sa-333ccb83de857371cd1885d48c40d88a.svg";